export const heroData = {
  headline: "Budget Together,\nStress Less",
  subheadline:
    "Shared Spend makes it easy to create and track shared budgets with your household, roommates, or anyone you split costs with.",
  ctaPrimary: "Join the Waitlist",
  ctaSecondary: "See Features",
  waitlistUrl: "/shared-spend/waitlist",
  badge: "Coming Soon to iOS",
};

export const featuresData = [
  {
    id: "shared-budgets",
    icon: "users",
    title: "Shared Budgets",
    description:
      "Create budgets with your household, partner, or friends and track spending together in real time.",
  },
  {
    id: "expense-logging",
    icon: "receipt",
    title: "Expense Logging",
    description:
      "Log expenses instantly with an amount, note, and category. Every member sees it as soon as it's added.",
  },
  {
    id: "real-time-sync",
    icon: "sync",
    title: "Real-Time Sync",
    description:
      "All budget members share the same live view. No manual reconciling, no stale data.",
  },
  {
    id: "smart-alerts",
    icon: "bell",
    title: "Spend Alerts",
    description:
      "Get a push notification before your group hits its limit — so you can adjust before it's too late.",
  },
  {
    id: "budget-terms",
    icon: "calendar",
    title: "Flexible Terms",
    description:
      "Weekly, monthly, or custom time windows to match the way you and your group actually spend.",
  },
  {
    id: "categories",
    icon: "tag",
    title: "Spending Categories",
    description:
      "Organize every expense across Food, Transport, Bills, Entertainment, Shopping, and more.",
  },
];

export const howItWorksData = [
  {
    step: 1,
    title: "Connect",
    description:
      "Invite a partner, roommate, or family member. They accept and you're linked.",
    icon: "link",
  },
  {
    step: 2,
    title: "Create",
    description:
      "Set a budget name, total amount, time period, and spending categories.",
    icon: "plus",
  },
  {
    step: 3,
    title: "Track",
    description: "Log expenses as you go. Stay under the limit — together.",
    icon: "check",
  },
];

export const faqData = [
  {
    id: "what-is",
    question: "What is Shared Spend?",
    answer:
      "Shared Spend is an iOS app that lets two or more people create and track a shared budget. You connect with the people you share expenses with, set a spending limit and time period, and log costs together in real time.",
  },
  {
    id: "when",
    question: "When will it be available?",
    answer:
      "We're in development now. Join the waitlist and you'll be the first to know when it launches on the App Store.",
  },
  {
    id: "who",
    question: "Who is it for?",
    answer:
      "Anyone who shares spending with another person — couples managing a household budget, roommates splitting bills, or friends planning a group trip.",
  },
  {
    id: "security",
    question: "Is my financial data secure?",
    answer:
      "Yes. All data is stored in Firebase with strict security rules so only members of a budget can see it. Data is encrypted in transit and at rest. We never sell your data.",
  },
  {
    id: "visibility",
    question: "Can other members see my expenses?",
    answer:
      "Yes — that's the point. All members of a shared budget can see each expense amount, note, and category. Only people you explicitly invite to a budget can access it.",
  },
  {
    id: "free",
    question: "Will it be free?",
    answer:
      "We'll offer a free tier. Full pricing details will be announced closer to launch — join the waitlist to be notified.",
  },
];

export const ctaData = {
  headline: "Be First to Know When We Launch",
  subheadline:
    "Join the waitlist and get notified the moment Shared Spend is available on iOS.",
  cta: "Join the Waitlist",
  waitlistUrl: "/shared-spend/waitlist",
};

export const navigationLinks = [
  { id: "features", label: "Features" },
  { id: "how-it-works", label: "How It Works" },
  { id: "faq", label: "FAQ" },
];
